import React, { useContext } from "react"

import { ThemeContext } from 'components/basics/theme/Theme'

import * as st from './Button.styled.js'

const Button = ({
  className,
  type,
  htmlType,
  size,
  view,
  icon,
  href,
  target,
  eventName,
  isPressed,
  isProgress,
  isDisabled,
  onClick,
  children
}) => {
  const theme = useContext(ThemeContext)

  const Icon = icon
  const Component = type === "a"
        ? st.A : type === "link"
        ? st.Link : st.Button

  return (
    <Component
      type={htmlType}
      className={className}
      size={size}
      view={view}
      to={href}
      href={href}
      theme={theme}
      target={target}
      isPressed={isPressed}
      data-event={eventName}
      disabled={isProgress || isDisabled}
      onClick={onClick}
    >
      <st.Content
        size={size}
        isProgress={isProgress}
      >
        {Icon && <Icon />}
        {children}
      </st.Content>
      {isProgress && <st.Loader />}
    </Component>
  )
}

export default Button
